export const OptionalLabel = ({text} : {text?: string}) => {
  return <span className="text-subtle ml-1 text-xs">{ text ?? "(Optional)"}</span>;
};
